module.exports = __webpack_public_path__ + "img/mobilize-logo.099bacbf.png";